import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetDesigns } from 'domains/Design/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../CustomerProfileFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const DesignFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [designs] = useGetDesigns()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'designs',
    operand: 'array-contains'
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`design-details-visibility`) === 'opened'}>
      <summary style={summaryStyles} onClick={() => onToggleDetails('design')}>
        {t('Design')}
      </summary>
      {designs?.map((design, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(design)}
            onChange={() => onChange(design)}>
            <Text wordBreak="break-all">
              {design?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

DesignFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default DesignFilter
